import 'css-chunksrc/client/scenes/event/details/nameForm/styles.scss';export default {
  "input": "_input_1jabk_1",
  "invalid": "_invalid_1jabk_16"
};